// Dil kodu → temsili bayrak (ülke seçici gibi tatlı bir UI için). Diller ülkelere
// birebir oturmaz; en yaygın temsili bayrağı seçiyoruz, bilinmeyende 🌐.
const LANG_FLAG: Record<string, string> = {
  tr: '🇹🇷', en: '🇬🇧', de: '🇩🇪', fr: '🇫🇷', es: '🇪🇸', it: '🇮🇹', pt: '🇵🇹',
  nl: '🇳🇱', ru: '🇷🇺', uk: '🇺🇦', pl: '🇵🇱', ar: '🇸🇦', fa: '🇮🇷', he: '🇮🇱',
  zh: '🇨🇳', ja: '🇯🇵', ko: '🇰🇷', hi: '🇮🇳', id: '🇮🇩', ms: '🇲🇾', th: '🇹🇭',
  vi: '🇻🇳', el: '🇬🇷', ro: '🇷🇴', hu: '🇭🇺', cs: '🇨🇿', sv: '🇸🇪', no: '🇳🇴',
  da: '🇩🇰', fi: '🇫🇮', bg: '🇧🇬', hr: '🇭🇷', sr: '🇷🇸', sk: '🇸🇰', az: '🇦🇿',
  ka: '🇬🇪', hy: '🇦🇲', ur: '🇵🇰', bn: '🇧🇩', ta: '🇮🇳', sw: '🇰🇪', af: '🇿🇦',
};

// Bölgeye özgü tam kod eşleşmesi — genel taban koddan (ör. 'pt'→🇵🇹) önce
// kontrol edilir. Brezilya Portekizcesi Portekiz'den ayrı, doğru bayrağı alsın diye.
const LANG_FLAG_FULL: Record<string, string> = {
  'pt-br': '🇧🇷',
};

export function flagForLang(code: string): string {
  const lower = (code ?? '').toLowerCase();
  return LANG_FLAG_FULL[lower] ?? LANG_FLAG[lower.split('-')[0]] ?? '🌐';
}
